import React, { useState } from 'react';
import type { ClientOrderItem } from '../types';

interface Props {
  onClose: () => void;
  onSubmit: (payload: Partial<ClientOrderItem>) => Promise<void>;
}

export const CreateOrderModal: React.FC<Props> = ({ onClose, onSubmit }) => {
  const [title, setTitle] = useState('');
  const [journal, setJournal] = useState('');
  const [category, setCategory] = useState('Language and Linguistics');
  const [database, setDatabase] = useState('Scopus');
  const [quartile, setQuartile] = useState('Q2');
  const [percentile, setPercentile] = useState('73');
  const [clientName, setClientName] = useState('');
  const [clientEmail, setClientEmail] = useState('');
  const [totalAmount, setTotalAmount] = useState('850000');
  const [paidAmount, setPaidAmount] = useState('850000');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!title.trim() || !journal.trim()) return;

    setIsSubmitting(true);
    try {
      await onSubmit({
        article_title: title.trim(),
        journal: journal.trim(),
        category,
        database,
        quartile,
        percentile,
        client_name: clientName.trim() || 'Клиент ЗА',
        client_email: clientEmail.trim() || 'client@example.kz',
        total_amount: parseInt(totalAmount, 10) || 850000,
        paid_amount: parseInt(paidAmount, 10) || 0,
        status: 'Принято',
        stage: 'Ожидает публикации',
        payment_state: parseInt(paidAmount, 10) >= parseInt(totalAmount, 10) ? 'Оплачено' : 'Частично',
      });
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="orders-pub-modal-backdrop" onClick={onClose}>
      <div
        className="orders-pub-modal"
        style={{ maxWidth: '680px' }}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="orders-pub-modal-header">
          <div>
            <div className="orders-pub-eyebrow">CRM · НОВЫЙ ЗАКАЗ</div>
            <h3>Создание клиентского заказа</h3>
          </div>
          <button type="button" className="orders-pub-close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="orders-pub-modal-body">
            <div className="orders-pub-field-group">
              <span className="orders-pub-field-label">Название статьи *</span>
              <input
                type="text"
                className="orders-pub-input"
                required
                placeholder="Полное наименование научной статьи..."
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <div className="orders-pub-grid-2">
              <div className="orders-pub-field-group">
                <span className="orders-pub-field-label">Журнал *</span>
                <input
                  type="text"
                  className="orders-pub-input"
                  required
                  placeholder="Theory and Practice in Language Studies"
                  value={journal}
                  onChange={(e) => setJournal(e.target.value)}
                />
              </div>
              <div className="orders-pub-field-group">
                <span className="orders-pub-field-label">Категория / Направление</span>
                <input
                  type="text"
                  className="orders-pub-input"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                />
              </div>
            </div>

            <div className="orders-pub-grid-3">
              <div className="orders-pub-field-group">
                <span className="orders-pub-field-label">База данных</span>
                <select
                  className="orders-pub-select"
                  value={database}
                  onChange={(e) => setDatabase(e.target.value)}
                >
                  <option value="Scopus">Scopus</option>
                  <option value="Web of Science">Web of Science</option>
                  <option value="CCES">КОКСНВО / CCES</option>
                </select>
              </div>
              <div className="orders-pub-field-group">
                <span className="orders-pub-field-label">Квартиль</span>
                <select
                  className="orders-pub-select"
                  value={quartile}
                  onChange={(e) => setQuartile(e.target.value)}
                >
                  <option value="Q1">Q1</option>
                  <option value="Q2">Q2</option>
                  <option value="Q3">Q3</option>
                  <option value="Q4">Q4</option>
                </select>
              </div>
              <div className="orders-pub-field-group">
                <span className="orders-pub-field-label">Процентиль</span>
                <input
                  type="text"
                  className="orders-pub-input"
                  value={percentile}
                  onChange={(e) => setPercentile(e.target.value)}
                />
              </div>
            </div>

            <div className="orders-pub-grid-2">
              <div className="orders-pub-field-group">
                <span className="orders-pub-field-label">ФИО Клиента</span>
                <input
                  type="text"
                  className="orders-pub-input"
                  placeholder="Айдар Мусин"
                  value={clientName}
                  onChange={(e) => setClientName(e.target.value)}
                />
              </div>
              <div className="orders-pub-field-group">
                <span className="orders-pub-field-label">Email клиента</span>
                <input
                  type="email"
                  className="orders-pub-input"
                  placeholder="client@example.kz"
                  value={clientEmail}
                  onChange={(e) => setClientEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="orders-pub-grid-2">
              <div className="orders-pub-field-group">
                <span className="orders-pub-field-label">Общая стоимость (₸)</span>
                <input
                  type="number"
                  className="orders-pub-input"
                  value={totalAmount}
                  onChange={(e) => setTotalAmount(e.target.value)}
                />
              </div>
              <div className="orders-pub-field-group">
                <span className="orders-pub-field-label">Внесенный платеж (₸)</span>
                <input
                  type="number"
                  className="orders-pub-input"
                  value={paidAmount}
                  onChange={(e) => setPaidAmount(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="orders-pub-modal-footer">
            <button
              type="submit"
              className="orders-pub-primary-btn"
              disabled={isSubmitting}
            >
              Создать заказ
            </button>
            <button
              type="button"
              className="orders-pub-close-btn"
              onClick={onClose}
            >
              Отмена
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
